import EventEdit from "@share/event-edit/EventEdit.vue";
import { noticeActions } from "@service/store/notice/actions";
import { NoticeLevel } from "@service/components/toast/type/Enums";
import { AdminPanelEventObserverBase } from "@share/event-edit/observers/AdminPanelEventObserverBase";
import { Event } from "@api/models/Event";
import { ObjectDataParamsInterface } from "@api/repositories/interfaces/ObjectDataParamsInterface";

export class OnSaveObserver extends AdminPanelEventObserverBase {
    constructor(protected readonly component: EventEdit) {
        super('onGreen');
    }

    private dispatchEventToStore(data: ObjectDataParamsInterface) {
        let event: Event | null = null;

        if (
            this.component.languagesService?.userLanguage &&
            data?.languages &&
            data.languages[this.component.languagesService?.userLanguage]
        ) {
            event = new Event(data.languages[this.component.languagesService.userLanguage], this.component.schemaId);
        }
        else if (data?.fields) {
            event = new Event(data.fields, this.component.schemaId);
        }

        this.component.$store.dispatch('events/updateEvent', event);
    }

    private savingFailHandler() {
        this.component.$store.dispatch(noticeActions.submitNotice, {
            text: this.component.$t("event.notifications.failedToSave").toString(),
            level: NoticeLevel.danger
        });
    }

    async handler() {
        if (!this.component.event) { return; }

        this.component.$v.$touch();

        if (this.component.$v.$invalid) { return; }

        this.component.$store.dispatch("showSpinner");

        if (this.component.event.base?.beginAt) {
            this.component.event.base.beginAt = this.component.event.base.beginAt.startOf('day');
        }

        if (this.component.event.base?.endAt) {
            this.component.event.base.endAt = this.component.event.base.endAt.endOf('day');
        }

        try {
            const result = await this.component.objectsService?.update(this.component.schemaId, this.component.eventId, this.component.event);

            if (result) {
                this.component.$store.dispatch(noticeActions.submitNotice, {
                    text: this.component.$t("event.notifications.successfullySaved").toString(),
                    level: NoticeLevel.success
                });

                if (result.fields?.updatedAt) {
                    this.component.event.setUpdatedAt(result.fields.updatedAt);
                }

                if (this.component.objectResetter) {
                    this.component.objectResetter.doCopy();
                    this.component.objectResetter.needToReset = false;
                }

                //@todo think about common realtime event
                this.dispatchEventToStore(result);
            }
            else {
                this.savingFailHandler();
            }
        }
        catch(e) {
            this.savingFailHandler();
            this.component.$store.dispatch('reportException', e, { root: true });
        }

        this.component.$store.dispatch("hideSpinner");
    }
}
